import type { VILCOpportunitiesComponent } from "./vilc-opportunities.component";
import type { VilcWorkflowDependencies } from "./vilc-opportunities-workflow-dependencies";

type VilcFilesWorkflowContext = Pick<
  VILCOpportunitiesComponent,
  | "gbFactor"
  | "mbFactor"
  | "kbFactor"
  | "rows"
  | "excelHeader"
  | "uploadedFile"
  | "fileUploadContent"
  | "parseFileSize"
  | "buttonDisabled"
  | "onFileUploadApiCall"
  | "fileTypeValidation"
  | "expId"
  | "commonFileApiCall"
  | "runValidationAPI"
  | "allowedFileType"
>;
export class VilcFilesWorkflow {
  parseFileSize(
    context: VilcFilesWorkflowContext,
    _dependencies: VilcWorkflowDependencies,
    sizeInBytes: any,
  ): string {
    const factor =
      sizeInBytes > context.gbFactor
        ? context.gbFactor
        : sizeInBytes > context.mbFactor
          ? context.mbFactor
          : context.kbFactor;
    const suffix =
      factor === context.gbFactor
        ? " GB"
        : factor === context.mbFactor
          ? " MB"
          : " KB";
    const size = sizeInBytes / factor;
    return String(parseFloat(size.toFixed(1))) + suffix;
  }
  onDownloadResults(
    context: VilcFilesWorkflowContext,
    dependencies: VilcWorkflowDependencies,
  ): void {
    const excelRows = context.rows.map((row) => ({
      ...row,
      financially_viable:
        row.financially_viable === true
          ? "Yes"
          : row.financially_viable === false
            ? "No"
            : row.financially_viable,
      have_new_value:
        row.have_new_value === true
          ? "Yes"
          : row.have_new_value === false
            ? "No"
            : row.have_new_value,
    }));
    dependencies.stateService.exportToExcel(
      context.excelHeader,
      excelRows,
      "vilc_opportunities",
    );
  }
  onFileDrop(
    context: VilcFilesWorkflowContext,
    _dependencies: VilcWorkflowDependencies,
    event: any,
  ): void {
    const droppedFiles: FileList = event.file.dataTransfer.files;
    context.uploadedFile = droppedFiles[0];
    context.fileUploadContent["fileName"] = String(context.uploadedFile.name);
    context.fileUploadContent["filesize"] = context.parseFileSize(
      context.uploadedFile.size,
    );
    context.fileUploadContent["loaderFlag"] = true;
    context.buttonDisabled = false;
    context.onFileUploadApiCall();
  }
  onFileBrowse(
    context: VilcFilesWorkflowContext,
    _dependencies: VilcWorkflowDependencies,
    e: any,
  ): void {
    if (e?.target?.files?.[0]) {
      context.uploadedFile = e.target.files[0];
      context.fileUploadContent["fileName"] = String(context.uploadedFile.name);
      context.fileUploadContent["filesize"] = context.parseFileSize(
        context.uploadedFile.size,
      );
      context.fileUploadContent["loaderFlag"] = true;
      context.buttonDisabled = false;
      context.onFileUploadApiCall();
    }
  }
  onFileUploadCancel(
    context: VilcFilesWorkflowContext,
    _dependencies: VilcWorkflowDependencies,
    _event: any = "",
  ): void {
    context.uploadedFile = [];
    context.fileUploadContent["fileName"] = "";
    context.fileUploadContent["filesize"] = "";
    context.fileUploadContent["fileUploadStatus"] = false;
    context.fileUploadContent["loaderFlag"] = false;
    context.fileUploadContent["fileUploadPercent"] = 0;
    context.buttonDisabled = true;
  }
  onFileUploadApiCall(
    context: VilcFilesWorkflowContext,
    dependencies: VilcWorkflowDependencies,
  ): void {
    context.fileUploadContent.fileUploadErrorMessage = "";
    if (!context.fileTypeValidation()) {
      return;
    }
    const data = new FormData();
    context.fileUploadContent["fileName"] = String(context.uploadedFile.name);
    context.fileUploadContent["filesize"] = context.parseFileSize(
      context.uploadedFile.size,
    );

    data.append("upload_file", context.uploadedFile, context.uploadedFile.name);

    context.fileUploadContent["loaderFlag"] = true;

    let apiUrl = "";
    apiUrl = `${dependencies.stateService.apiList.experiments.phoExperiments}/${context.expId}/file/dtp_vilc`;

    context.commonFileApiCall(
      apiUrl,
      "postFileMethod",
      data,
      (response: any, _params: any) => {
        if (response?.status === "progress") {
          context.fileUploadContent["fileUploadStatus"] = true;
          context.fileUploadContent["fileUploadPercent"] = response.percent;
        } else if (
          response?.task_id ||
          response?.message === "File saved to BLOB"
        ) {
          context.fileUploadContent["loaderFlag"] = false;
          context.fileUploadContent["fileUploadStatus"] = true;
          context.fileUploadContent["fileUploadedFlag"] = true;
          context.fileUploadContent["fileUploadPercent"] = 100;
          context.runValidationAPI("postMethod");
          context.buttonDisabled = false;
        }
      },
    );
  }
  fileTypeValidation(
    context: VilcFilesWorkflowContext,
    _dependencies: VilcWorkflowDependencies,
  ): boolean {
    let c = 0;
    context.allowedFileType.map((f: any) => {
      if (context.uploadedFile.type === f) {
        c = 1;
      }
    });
    if (c === 0) {
      context.fileUploadContent["fileUploadErrorMessage"] =
        "Invalid file format. Accepted formats: CSV, XLS, XLSX. Please re-upload the file.";
      return false;
    } else {
      return true;
    }
  }
}
